


































import { Component, Prop, Vue } from "vue-property-decorator";
import AppUserUnit from "@/components/atom/AppUserUnit.vue";
import BgmController from "@/components/controller/BgmController.vue";
import VrSpaceContents from "@/components/vr-spaces/VrSpaceContents.vue";
import {Sweep} from "@/params/Sweep";

@Component({
  components: {
    BgmController,
    AppUserUnit
  }
})
export default class ApplicationHeaderBar extends Vue {
  public bgmController: BgmController;

  /**
   * VR空間上の現在のカメラポジションオブジェクト（Sweep）
   */
  @Prop() currentSweep: Sweep = null;

  /**
   * 表示するページタイトル
   */
  @Prop() pageTitle: string;


  /* Computed Property */
  get isSmp (): boolean {
    return this.$store.state.isSmp;
  }


  /* Lifecycle Hook */
  mounted (): void {
    this.$nextTick(() => {
      this.bgmController = <BgmController> this.$refs.bgmController;
    });
  }


  private onUserLogout (): void {
    this.$store.dispatch('logout')
    .then((result) => {
      // BGMコンテンツをリセットする
      this.bgmController.reset();
      // ページリロード
      this.$router.push('/');
    })
    .catch((err) => {
      console.log(err);
    });
  }

}
